export default __webpack_public_path__ + "static/media/ltr_student_devices_mockup.89a1dd54.png";